// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'
import { Field } from 'redux-form'

import {
  InfoLabel,
  LabeledInput,
  RadioGroupFromState,
  SelectFromState,
} from 'components/Form'

const inputRowClass = `display-flex justify-content-between align-items-start flex-wrap-nowrap`

// also used to fill placeholder space because parent justifies content between
const liw = {
  width: `15%`,
}

const modulationDetailLabel = (
  <InfoLabel
    label={'Modulation Detail'}
    info={'Description of the radio modulations; e.g. "max throughput" or "low Latency"'} />
)

const powerOptionLabel = (
  <InfoLabel
    label={'Power Option'}
    info={'Description of the radio power capabilities; e.g. "HP" or "SP"'} />
)

const AdvancedSearch = ({ idRoot }) => (
  <div>
    <ul className={inputRowClass}>
      <li style={liw}>
        <Field
          component={SelectFromState}
          emptyOptionLabel={`All`}
          id={`${idRoot}status`}
          name={`adv-statusId`}
          selectLabel={`Status`}
          targetSet={[`radioSettings`, `statuses`]}
          valueKeyRoot={'status'} />
      </li>
      <li style={liw}>
        <RadioGroupFromState
          emptyOptionLabel={'All'}
          idRoot={`${idRoot}modulation-type`}
          label={`Modulation Type`}
          name={`adv-modulationTypeId`}
          targetSet={['radioSettings', 'modulationTypes']} />
      </li>
      <li style={liw}>
        <Field
          component={LabeledInput}
          id={`${idRoot}modulation`}
          label={`Modulation`}
          name={`adv-modulationSchemeDescription`}
          placeholder={`Modulation`} />
      </li>
      <li style={liw}>
        <Field
          component={LabeledInput}
          id={`${idRoot}modulation-detail`}
          label={modulationDetailLabel}
          name={`adv-modulationDescription`}
          placeholder={`Modulation Detail`} />
      </li>
      <li style={liw}>
        <Field
          component={LabeledInput}
          id={`${idRoot}throughput`}
          label={'Throughput (Mbps)'}
          name={`adv-throughput`}
          placeholder={`Throughput or Min : Max`} />
      </li>
    </ul>
    <ul className={inputRowClass}>
      <li style={liw}>
        <Field
          component={SelectFromState}
          emptyOptionLabel={`All`}
          id={`${idRoot}architectures`}
          name={`adv-architectureId`}
          selectLabel={`Architecture`}
          targetSet={[`radioSettings`, `architectures`]}
          valueKeyRoot={'architecture'} />
      </li>
      <li style={liw}>
        <Field
          id={`${idRoot}power-option`}
          label={powerOptionLabel}
          name={`adv-powerType`}
          component={LabeledInput}
          placeholder={`Power Option`} />
      </li>
      <li style={liw}>
        <Field
          id={`${idRoot}power`}
          label={'Power (dBm)'}
          name={`adv-txPowerMax`}
          component={LabeledInput}
          placeholder={'Number or Min : Max'} />
      </li>
      <li style={liw}>
        <Field
          component={SelectFromState}
          emptyOptionLabel={`All`}
          id={`${idRoot}radio-type`}
          name={`adv-radioTypeId`}
          selectLabel={`Radio Type`}
          targetSet={[`radioSettings`, `radioTypes`]}
          valueKeyRoot={'radioType'} />
      </li>
      <li style={liw}>
        <Field
          id={`${idRoot}filter-reference-code`}
          label={'Filter Reference Code'}
          name={`adv-filterReferenceCode`}
          component={LabeledInput} />
      </li>
    </ul>
  </div>
)

AdvancedSearch.propTypes = {
  change: func.isRequired,
  idRoot: string.isRequired,
}

export default AdvancedSearch
